"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataDescription = void 0;
var lodash_1 = require("lodash");
var array2d_1 = require("./array2d");
var domain_1 = require("./domain");
exports.DataDescription = {
  /** Return a `DataDescription` with no data. */
  empty: function () {
    return {
      data: [],
      xDomain: [null],
      yDomain: [null],
      x: function () {
        return null;
      },
      y: function () {
        return null;
      }
    };
  },
  /** Place data items into a 2D array, return the 2D array and domains. */
  toArray2D: function (data) {
    var items = data.data,
      x = data.x,
      y = data.y,
      filter = data.filter;
    var xDomain = domain_1.Domain.create(data.xDomain);
    var yDomain = domain_1.Domain.create(data.yDomain);
    var nColumns = xDomain.values.length;
    var nRows = yDomain.values.length;
    var arr = new Array(nColumns * nRows).fill(undefined);
    var xFunction = typeof x === 'function' ? x : function (d, i) {
      return x[i];
    };
    var yFunction = typeof y === 'function' ? y : function (d, i) {
      return y[i];
    };
    var warnedX = false;
    var warnedY = false;
    for (var i = 0; i < items.length; i++) {
      var d = items[i];
      var xValue = xFunction(d, i);
      var yValue = yFunction(d, i);
      var ix = xDomain.index.get(xValue);
      var iy = yDomain.index.get(yValue);
      if (ix === undefined) {
        if (!warnedX) {
          console.warn('Some data items map to X values out of the X domain:', d, 'maps to X', xValue);
          warnedX = true;
        }
      } else if (iy === undefined) {
        if (!warnedY) {
          console.warn('Some data items map to Y values out of the Y domain:', d, 'maps to Y', yValue);
          warnedY = true;
        }
      } else if (filter !== undefined && !filter(d, xValue, yValue, ix, iy)) {
        // skipping this item
      } else {
        arr[nColumns * iy + ix] = d;
      }
    }
    var array2d = array2d_1.Array2D.create(nColumns, nRows, arr);
    return {
      array2d: array2d,
      xDomain: xDomain,
      yDomain: yDomain
    };
  },
  /** Create random data */
  createRandom: function (nColumns, nRows) {
    var raw = array2d_1.Array2D.createRandom(nColumns, nRows);
    return {
      data: raw.values,
      x: function (d, i) {
        return i % nColumns;
      },
      y: function (d, i) {
        return Math.floor(i / nColumns);
      },
      xDomain: (0, lodash_1.range)(nColumns),
      yDomain: (0, lodash_1.range)(nRows)
    };
  },
  /** Create partly random data having a gradient from left to right, and special values around the edges */
  createDummy: function (nColumns, nRows) {
    var raw = array2d_1.Array2D.createDummy(nColumns, nRows);
    return {
      data: raw.values,
      x: function (d, i) {
        return i % nColumns;
      },
      y: function (d, i) {
        return Math.floor(i / nColumns);
      },
      xDomain: (0, lodash_1.range)(nColumns),
      yDomain: (0, lodash_1.range)(nRows)
    };
  }
};